import type React from 'react'

import { AvatarInfo, AvatarMenu } from './components'
import css from './styles.module.css'

interface Props extends React.PropsWithChildren {
  onUpload: (files: FileList | null) => void
  onDelete: () => void
}

export const AvatarRow: React.FC<Props> = ({
  onUpload,
  onDelete,
  children,
}) => {
  return (
    <div className={css.avatar_row}>
      <AvatarInfo />
      <AvatarMenu onUpload={onUpload} onRemove={onDelete}>
        {children}
      </AvatarMenu>
    </div>
  )
}
